export default __webpack_public_path__ + "static/media/Mask Group 1 1.96549147.png";